import { render, staticRenderFns } from "./modalControlReparto.vue?vue&type=template&id=4a05dde4&"
import script from "./modalControlReparto.vue?vue&type=script&lang=js&"
export * from "./modalControlReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports